<ng-template [ngIf]="!meta">
    <div class="alert alert-info alert-no-meta">
        <h5 class="alert-heading">
           <i class="fas fa-info" aria-hidden="true"></i> Nenhuma Meta Selecionada
        </h5>
        <p class="m-0">Selecione uma meta no filtro para poder lançar a análise de mercado</p>
    </div>
</ng-template>

<ng-template [ngIf]="meta">
    <!-- List -->
    <sgt-cliente-analise-mercado-perspectiva-projetada-list
        *ngIf="isVisualizacaoModoList"
        #list
        [filter]="filter"
        [isMesAtual]="isMesAtual"
        [controleQuantidade]="meta?.controleQuantidade"
        [controlePeso]="meta?.controlePeso"
        [controleValor]="meta?.controleValor"
        [isPerspectivaMeta]="true"
        [meta]="meta"
        [metaTotais]="metaTotais">
    </sgt-cliente-analise-mercado-perspectiva-projetada-list>
</ng-template>


